import React from 'react';
import { colors } from '../styles/fontStyles';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';
import GhostButton from '../components/common/buttons/GhostButton';

type FilterByGenderButtonProps = {
  filter: string;
  isFilterSelected: (filter: string) => boolean;
  handleFilterToggle: (filter: string) => void;
};

const FilterbyGenderButton = ({ filter, isFilterSelected, handleFilterToggle }: FilterByGenderButtonProps) => {
  const { theme } = useThemeContext();
  const thisFilterIsSelected = isFilterSelected(filter);
  return (
    <GhostButton
      key={filter}
      sxProps={{
        color: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelected.color : theme.custom.report.timeline.filterByGender.buttonNotSelected.color,
        fontSize: '14px',
        fontWeight: 700,
        padding: '6px 12px',
        justifyContent: 'center',
        minWidth: '120px',
        alignItems: 'center',
        borderRadius: '8px',
        height: '32px',
        borderColor: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelected.borderColor : theme.custom.report.timeline.filterByGender.buttonNotSelected.borderColor,
        backgroundColor: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelected.backgroundColor : theme.custom.report.timeline.filterByGender.buttonNotSelected.backgroundColor,
        '&:hover': {
          border: '2px solid',
          color: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelectedHover.color : theme.custom.report.timeline.filterByGender.buttonNotSelectedHover.color,
          borderColor: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelectedHover.borderColor : theme.custom.report.timeline.filterByGender.buttonNotSelectedHover.borderColor,
          backgroundColor: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelectedHover.backgroundColor : theme.custom.report.timeline.filterByGender.buttonNotSelectedHover.backgroundColor,
          [theme.breakpoints.up('md')]: {
            borderColor: thisFilterIsSelected ? theme.custom.report.timeline.filterByGender.buttonSelectedHover.borderColor : theme.custom.report.timeline.filterByGender.buttonNotSelectedHover.borderColor,
          },
        },
      }}
      additionalProps={{
        style: { borderRadius: '8px', height: '32px' },
        startIcon: isFilterSelected(filter) ? (
          <img src={theme.custom.report.timeline.filterByGender.iconImageSrc} alt={'Selected'} style={{ width: '18px', height: '18px' }} />
        ) : null,
      }}
      onClick={() => handleFilterToggle(filter)}
      buttonText={filter}
      variant={'outlined'}
    />
  );
};

export default FilterbyGenderButton;
